define(function(require) {
  var Uploader = function(element, prop) {
    this._element = element;
    this._inputFile = element.find("input[type=file]");
    this._cacheInputFile = element.find("input.cached_file");
    this._imgElement = element.find("img") || null;
    this._linkElement = element.find("a") || null;
    this._uploudContent = element.find(".upload-content");
    this._button = $(this._uploudContent.find("button")[0]);
    this._progressBar = this._uploudContent.find(".progress-bar");
    this._elementRemove = element.find('.destroy-file');

      /*if(prop.field_name){
       this._uploudContent.find(".title span").html(prop.field_name);
       }*/

    this._button.text("Upload an image");
    this._isImgUploader = true;
    this._responseField = 'photo_url';
    this._isAttachment = false;

    if(prop.type == "file") {
      this._acceptFileTypes = /(\.|\/)(pdf)$/i;
      this._button.text("Upload a CV file");
      this._isImgUploader = false;
      this._responseField = 'resume_url';

      if(this._linkElement.length) {
        this._button.text("Change a CV file");
        this._uploudContent.addClass("upload-file");
        this._uploudContent.find(".title").html("<a href='"+this._linkElement.attr("href")+"' target='_blank'><i class='fa fa-file-pdf-o'></i></a><span class='file-type'>"+this._element.attr('data-filename')+"</span>");
      }
      else {
        this._uploudContent.find('.title i').addClass('fa-file-pdf-o grey');
        this._uploudContent.find(".title .file-type").html('PDF accepted');
      }
      if(this._element.attr('data-title') !== ''){
        this._button.text(this._element.attr('data-title'));
      }
      if(this._element.attr('data-accepted-title') !== ''){
        this._uploudContent.find(".title .file-type").html(this._element.attr('data-accepted-title'));
      }
      if(this._element.attr('data-change-title') !== ''){
        this._button.text(this._element.attr('data-change-title'));
      }
      if(this._element.attr('data-accepted-type') === 'pdf-word'){
        this._acceptFileTypes = /(\.|\/)(pdf|doc|docx)$/i;
      }
    }
    else if(prop.type == "image") {
      this._responseField = 'photo_url';

      if(this._imgElement && this._imgElement.attr("src")) {
        this._isImgNotEmpty = true;
        this._button.text("Change an image");
        this._uploudContent.find('.title i').addClass('fa-camera');
        this._uploudContent.addClass("upload-remove");
      }
      else {
        this._uploudContent.find('.title i').addClass('fa-camera grey');
        this._imgElement.hide();
      }
      if(this._element.attr('data-title')){
        this._button.text(this._element.attr('data-title'));
      }
      if(this._element.attr('data-change-title')){
        this._button.text(this._element.attr('data-change-title'));
      }
      if(this._element.attr('data-recommended-size')){
        this._uploudContent.find('.recommended-size').html('Recommended aspect ratio: ' + this._element.attr('data-recommended-size'));
      }
      this._uploudContent.find(".title .file-type").html('JPG, JPEG, GIF & PNG accepted');
    }
    else if(prop.type == 'attachment') {
      this._acceptFileTypes = /(\.|\/)(pdf|doc|docx|jpg|jpeg|gif|png)$/i;
      this._button.text("Upload a file");
      this._isImgUploader = false;
      this._isAttachment = true;
      this._uploudContent.find('.title i').addClass('fa-file-pdf-o grey');
      this._uploudContent.find(".title .file-type").html('Document or image accepted');
      this._responseField = 'file_url';
    }

    this._button.on("click", $.proxy(this._onClick, this));
    this._button.on("focus blur", $.proxy(function(ev) {
      if(this._isImgNotEmpty && !this._isFileuploadstart) {
        this._uploudContent.addClass("upload-remove");
        this._imgElement.show();
      }
    }, this));
    this._elementRemove.on("click", $.proxy(this._onClickRemove, this));
    $(document).bind("dragover", $.proxy(this._onDragOver, this));

    if(prop.autoUpload != undefined) this._autoUpload = prop.autoUpload;

    this.initFileupload();
  };

  Uploader.prototype._element = null;
  Uploader.prototype._inputFile = null;
  Uploader.prototype._cacheInputFile = null;
  Uploader.prototype._dropZoneTimeout = null;
  Uploader.prototype._uploudContent = null;
  Uploader.prototype._button = null;
  Uploader.prototype._progressBar = null;
  Uploader.prototype._maxFileSize = 1024*1024; //1Mb
  Uploader.prototype._maxResolution = 800;
  Uploader.prototype._acceptFileTypes = /(\.|\/)(jpg|jpeg|gif|png)$/i;
  Uploader.prototype._reqFileTypes = /(\.|\/)([a-z]{2,3})$/i;
  Uploader.prototype._isImgNotEmpty = false;
  Uploader.prototype._isFileuploadstart = false;
  Uploader.prototype._isImgUploader = false;
  Uploader.prototype._autoUpload = true;

  Uploader.prototype.initFileupload = function() {
    var that = this;
    var originalAdd = $.blueimp.fileupload.prototype.options.add;

    this._uploudContent.fileupload({
      dataType: "json",
      type: 'PUT',
      url: this._inputFile.data("url"),
      dropZone: this._uploudContent,
      autoUpload : this._autoUpload,
      fileInput: this._inputFile,
      fileInputClone: false,
      //formData: $.proxy(this._formData, this),
      limitMultiFileUploads: 1,
      add: function(e, data) {
        var file = data.files[0];
        that._isFileuploadstart = true;

        if(file && that._acceptFileTypes.test(file.name) && file.size < that._maxFileSize) {
          data.data = new FormData();
          data.data.append('upl_file', file);

          if(that._autoUpload)
            originalAdd.call(this, e, data);
          else {
            //NOTE: old school style
            var obj = that._element.find("input[type=file]")[0];
            var parent = obj.parentNode;
            parent.replaceChild(that._inputFile[0], obj);
          }

        }
        else {
          if(data.fileInputClone) {
            that._inputFile = data.fileInputClone;
          }
          that._inputFile.val("");
          that._uploudContent.removeClass("upload-progress upload-done upload-remove").addClass("upload-error");

          if(file.size > that._maxFileSize) {
            //$(that._uploudContent.find(".upload-notice > .error")).text("file size must be less than 4Mb.");
            console.log("file.size", file.size);
          }
          else {
            var fileTypes = that._reqFileTypes.exec(file.name);
            //$(that._uploudContent.find(".upload-notice > .error")).text(fileTypes[0].toUpperCase() + " files are not supported.");
            console.log(fileTypes);
          }
        }
      },
      progress: $.proxy(function (e, data) {
        var progress = parseInt(data.loaded / data.total * 100, 10);
        this._progressBar.css("width", progress + "%");
      }, this),

      disableImageResize: /Android(?!.*Chrome)|Opera/
        .test(window.navigator && navigator.userAgent),
      imageMaxWidth: this._maxResolution,
      imageMaxHeight: this._maxResolution,
      imageForceResize: true,
      imageCrop: false // Force cropped images
    }).bind("fileuploadstart", $.proxy(function (e, data) {
      this._uploudContent.addClass("upload-progress");
      this._uploudContent.removeClass("upload-remove");
      this._imgElement.hide();
      this._isFileuploadstart = true;
      if (!this._isImgUploader && !this._isAttachment) {
        this._uploudContent.find(".title .file-type").html('PDF accepted');
      }
    },this))
      .bind("fileuploadprogress", function (e, data) {
        console.log(e, data);
      })
      .bind("fileuploaddone", $.proxy(this._onFileuploaddone, this))
      .bind("fileuploadchange", $.proxy(this._onFileuploadchange, this))
      .bind("fileuploadfail", $.proxy(this._onFileUploadFail, this));
  };

  Uploader.prototype._onFileuploadchange = function(ev, data) {
    if(this._autoUpload)
      return;

    if(this._isImgUploader){
      var file = data.files[0];
      var reader = new FileReader();
      var that = this;

      reader.onload = function (e) {
        that._isImgNotEmpty = true;
        that._imgElement.attr("src", e.target.result).show();
        that._uploudContent.addClass("upload-remove");
      };

      reader.readAsDataURL(file);
    } else {
      this._uploudContent.removeClass("upload-progress upload-done upload-error").addClass("upload-file");
      this._uploudContent.find(".title").html("<a href='javascript:void(0);'></a>");
    }
  };

  Uploader.prototype._onFileuploaddone = function(ev, data) {
    this._uploudContent.removeClass("upload-progress upload-error").addClass("upload-done");
    this._progressBar.css("width", 0);

    if(data.fileInputClone) {
      this._inputFile = data.fileInputClone;
    }
    this._inputFile.val("");

    var res = data.result;

    if(this._isImgUploader) {
      var img = new Image();

      if(this._imgElement.length == 0){
        this._imgElement = $('<img>');
        this._element.prepend(this._imgElement);
      }
      this._button.text("Change an image");
      this._uploudContent.find('.title i').removeClass('grey');
      img.onload = $.proxy(function () {
        this._uploudContent.removeClass("upload-progress upload-done upload-error").addClass("upload-remove");
        this._imgElement.attr('src', img.src);
        this._imgElement.show();
        this._isImgNotEmpty = true;
      }, this);
      img.src = res[this._responseField];
      this._cacheInputFile.val(res[this._responseField]);
    }
    else {
      if (this._isAttachment) {
        this._button.text("Change a file");
      } else {
        this._button.text("Change a CV file");
      };
      if(this._element.attr('data-change-title') !== ''){
        this._button.text(this._element.attr('data-change-title'));
      }
      this._uploudContent.removeClass("upload-progress upload-done upload-error");
      this._uploudContent.addClass('upload-file');
      //create | update link
      if(res[this._responseField]) {
        this._uploudContent.find(".title").html("<a href='" + res[this._responseField] + "' target='_blank'><i class='fa fa-file-pdf-o'></i></a><span class='file-type'>"+res.filename+"</span>");
        this._cacheInputFile.val(res[this._responseField]);
      }
    }

    this._isFileuploadstart = false;
  };

  Uploader.prototype._onFileUploadFail = function(ev, data) {
    this._uploudContent.removeClass("upload-progress upload-done").addClass("upload-error");
    //$(this._uploudContent.find(".upload-notice > .error")).text("We're sorry, but something went wrong.");
    console.log(ev, data);
    this._isFileuploadstart = false;
  };

  Uploader.prototype._onDragOver = function(ev) {
    if (!this._dropZoneTimeout) {

      if(this._uploudContent.hasClass("upload-remove")) {
        this._imgElement.hide();
      }

      this._uploudContent.removeClass("upload-progress upload-done upload-error upload-remove").addClass("in");
    } else {
      clearTimeout(this._dropZoneTimeout);
    }

    var found = false,
      node = ev.target;
    do {
      if (node === this._uploudContent[0]) {
        found = true;
        break;
      }
      node = node.parentNode;
    } while (node != null);
    if (found) {
      this._uploudContent.addClass("hover");
    } else {
      this._uploudContent.removeClass("hover");
    }
    this._dropZoneTimeout = setTimeout($.proxy(function () {
      this._dropZoneTimeout = null;
      this._uploudContent.removeClass("in hover");

      //if(this._isImgNotEmpty) {
      //    this._uploudContent.addClass("upload-remove");
      //    this._imgElement.show();
      //}
    }, this), 100);
  };

  Uploader.prototype._onClick = function(ev) {
    ev.stopPropagation();
    ev.preventDefault();

    this._uploudContent.removeClass("upload-error");

    if(this._isImgNotEmpty) {
      this._uploudContent.removeClass("upload-remove");
      this._imgElement.hide();
    }

    this._inputFile.click();
  };

  Uploader.prototype._onClickRemove = function(ev) {
    ev.preventDefault();
    var url = this._inputFile.data('destroy-url');

    if(url){
      var that = this;

      $.ajax({
        type: 'PUT',
        url: url,
        success: function(result){
          if(result.status == 'ok'){
            if(that._isImgUploader){
              that._imgElement.remove();
              that._imgElement.length = 0;
              that._isImgNotEmpty = false;
              that._uploudContent.removeClass('upload-remove');
            } else {
              that._uploudContent.find('.title').html('cv file');
              that._linkElement = null;
              that._uploudContent.removeClass('upload-file');
            }
          }
        }
      });
    }
  };

  return Uploader;
});
